import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import NotFound from "../extras/NotFound";
import WithNavbar from "../extras/PrivateRouteWithNavbar"
import CustomersTable from '../tables/CustomersTable'
import CreateCustomer from "../creation-forms/CreateCustomer";
import ViewCustomer from "../view-edit/ViewCustomer";

export default function Customers() {
    const match = useRouteMatch();
    return (
        <Switch>
            <WithNavbar exact path={match.path} component={CustomersTable} />
            <WithNavbar path={`${match.path}/create`} component={CreateCustomer} />
            <WithNavbar path={`${match.path}/view_:id`} component={ViewCustomer} />
            <Route path="*" component={NotFound} />
        </Switch>
    )
}